export const footerData = {
  brand: {
    logo: "/AEPL_lOGO.svg",
    name: "AEPL",
    fullName: "Anugraha Exceed Private Limited",
    description:
      "Five precision instruments. One integrated training intelligence layer.",
  },
  socialLinks: [
    {
      name: "Twitter",
      url: "https://x.com/Anugraha_Exceed",
      icon: "Twitter",
    },
    {
      name: "Linkedin",
      url: "https://www.linkedin.com/company/anugraha-exceed-incorporated/",
      icon: "Linkedin",
    },
    {
      name: "Instagram",
      url: "https://www.instagram.com/anugraha_exceed_pvt_ltd/",
      icon: "Instagram",
    },
    {
      name: "Facebook",
      url: "https://www.facebook.com/profile.php?id=61568297756356",
      icon: "Facebook",
    },
  ],
  sections: [
    {
      title: "Industries",
      links: [
        { label: "Aviation", url: "/industries/aviation" },
        { label: "Defence", url: "/industries/defence" },
        { label: "Energy", url: "/industries/energy" },
      ],
    },
    {
      title: "Platform",
      links: [
        { label: "RAPTOR", url: "/product/raptor" },
        { label: "LearnOn", url: "/product/learnon" },
        { label: "Aurora", url: "/product/aurora" },
        { label: "GRIFFIN XR", url: "/product/griffin" },
        { label: "CourseAI", url: "/product/courseai" },
      ],
    },
    {
      title: "About Us",
      links: [
        { label: "The Idea", url: "/about/the-idea" },
        { label: "Quest", url: "/about/quest" },
      ],
    },
    {
      title: "Contact",
      links: [{ label: "Contact us", isContact: true }],
    },
  ],
  trustedBy: [
    { name: "DRDO", logo: "/clients/DRDO.svg" },
    { name: "Indian Navy", logo: "/clients/IndianNavy.svg" },
    { name: "ISRO", logo: "/clients/ISRO.svg" },
    { name: "Etihad Airways", logo: "/clients/Etihad.svg" },
    { name: "IndiGo", logo: "/clients/Indigo.svg" },
  ],
  compliance: {
    title: "Compliant with",
    standards: [
      "EASA",
      "ICAO",
      "DGCA",
      "GCAA",
      "OPITO",
      "GWO",
      "NERC CIP",
      "WANO",
      "MIL-STD",
    ],
  },
  badges: ["ISO 27001", "Make in India"],
  offices: [
    {
      id: "india",
      location: "India — AEPL",
      flag: "🇮🇳",
      address:
        "Garuda BHIVE Workspace, BTM Layout, Bengaluru, Karnataka 560076",
      mapUrl: "https://maps.app.goo.gl/viCREuwhi4z3MRio7",
      embedUrl:
        "https://www.google.com/maps?q=Garuda+BHIVE+Workspace,+BTM+Layout,+Bengaluru,+Karnataka+560076&output=embed",
    },
    {
      id: "usa",
      location: "USA — AEI",
      flag: "🇺🇸",
      address: "ΑΕΙ, 1601-1 N Main Street #3159, Jacksonville, FL, USA 32206",
      mapUrl: "https://maps.app.goo.gl/8sARFKSXNSeWR48S7",
      embedUrl:
        "https://www.google.com/maps?q=1601+N+Main+Street,+Jacksonville,+FL+32206&output=embed",
    },
  ],
  contact: {
    email: "sales@anugraha.co",
    phone: "+91 636 184 2502",
    whatsapp: "916361842502",
    whatsappMessage: "I'd like to chat with you regarding AEPL Platforms",
  },
  copyright: "© 2026 Anugraha Exceed Pvt Ltd. All Rights Reserved.",
  legalLinks: [
    { label: "Terms & Conditions", url: "/legal" },
    { label: "Privacy Policy", url: "/privacy-policy" },
  ],
};
